import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {agent} from "../../../utils/agent";

//Fetch User Profile
export const getUserProfile = createAsyncThunk(
  "deleteProfile/getUserProfile",
  async (userId, { rejectWithValue }) => {
    try {
      const res = await agent.get(`/user/profile/${userId}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch profile");
    }
  }
);

//Send Delete Profile Request
export const sendDeleteRequest = createAsyncThunk(
  "deleteProfile/sendDeleteRequest",
  async ({ formData, id }, { rejectWithValue }) => {
    try {
      const res = await agent.post(`/user/delete-request/${id}`, formData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Something went wrong");
    }
  }
);

const deleteProfileSlice = createSlice({
  name: "deleteProfile",
  initialState: {
    loading: false,
    profile: {},
    setting: {},
    message: null,
    error: null,
  },

  reducers: {
    clearMessage: (state) => {
      state.message = null;
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(getUserProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.user;
        state.setting = action.payload.setting;
      })
      .addCase(getUserProfile.rejected, (state) => {
        state.loading = false;
      })

      // DELETE REQUEST
      .addCase(sendDeleteRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendDeleteRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
      })
      .addCase(sendDeleteRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearMessage } = deleteProfileSlice.actions;
export default deleteProfileSlice.reducer;
